module.exports = __webpack_public_path__ + "img/account_chart.d753dbe0.svg";